"use client"

/**
 * Renders 5 fading skeleton rows for the table preview.
 * Each row has cells matching the provided column count.
 */
export function SkeletonRows({ columnCount }: { columnCount: number }) {
  const rows = [1, 0.7, 0.45, 0.25, 0.1]

  return (
    <tbody>
      {rows.map((opacity, rowIdx) => (
        <tr key={rowIdx} style={{ opacity }}>
          {Array.from({ length: columnCount }).map((_, colIdx) => {
            // Vary the shimmer width per cell for a natural look
            const widths = ['60%', '75%', '45%', '80%', '55%', '70%', '40%', '65%']
            const width = widths[(rowIdx * 3 + colIdx) % widths.length]
            return (
              <td
                key={colIdx}
                className="border-b border-gray-100 px-3 py-3"
                style={{ height: 40 }}
              >
                <div
                  className="animate-pulse rounded"
                  style={{
                    width,
                    height: 14,
                    background: 'linear-gradient(90deg, #E6E8F3 25%, #D0D3E0 50%, #E6E8F3 75%)',
                    borderRadius: 4,
                  }}
                />
              </td>
            )
          })}
        </tr>
      ))}
    </tbody>
  )
}
